import "../styles/call-back.css";
import { useState, useEffect } from "react";
import BookingController from "../services/booking-controller";
import { toPersian10DigitDate } from "../utility";

export default function CallBackReservation(props) {
	const [isLoading, setIsLoading] = useState(true);
	const [reservation, setReservation] = useState({
		isPayment: false,
		code: "",
		trackingNumber: "",
		paymentDate: null,
		totalAmounWithoutDiscount: 0,
		discount: 0,
		couponDiscount: 0,
		totalAmount: 0,
		items: [
			{
				sortOrder: 0,
				reserveDate: new Date(),
				notes: "",
				unitCost: 0,
				quantity: 0,
				discount: 0,
				totalAmount: 0,
			},
		],
	});
	const [errorMessage, setErrorMessage] = useState("");
	//
	const bookingController = new BookingController();

	useEffect(() => {
		getData();
	}, []);

	const getData = async function () {
		try {
			if (window.isBusy === true) return;
			window.isBusy = true;
			setErrorMessage("");
			const queryParams = new URLSearchParams(
				window.location.href.split("?")[1]
			);
			var result = await bookingController.getReservation(
				queryParams.get("code")
			);
			if (result.isSuccess === false) throw result.message;
			setReservation(result.value);
		} catch (error) {
			setErrorMessage(error.toString());
		}
		window.isBusy = false;
		setIsLoading(false);
	};

	return (
		<article className="call-back">
			{isLoading === true && (
				<div>
					<h2>لطفا منتظر بمانید...</h2>
				</div>
			)}
			{isLoading === false && errorMessage && <p>{errorMessage}</p>}

			{isLoading === false && !errorMessage && (
				<>
					{reservation.isPayment === false && (
						<div className="cb-failed">
							<h2>پرداخت ناموفق</h2>
							<p>رزرو شما با کد {reservation.code} پرداخت نشده است</p>
						</div>
					)}
					{reservation.isPayment === true && (
						<div class="cb-success">
							<h2>پرداخت موفق</h2>
							<p>رزرو شما با موفقیت پرداخت و ثبت شد</p>
							<ul>
								<li>
									<label>کد رزرو</label>
									<i></i>
									<b>{reservation.code}</b>
								</li>
								<li>
									<label>شماره پیگیری</label>
									<i></i>
									<b>{reservation.trackingNumber}</b>
								</li>
								<li>
									<label>تاریخ پرداخت</label>
									<i></i>
									<b>
										{new Date(reservation.paymentDate)
											?.toLocaleString("fa-IR")
											.replace(",", " ساعت ")}
									</b>
								</li>
								<li>
									<label>هزینه قبل از تخفیف</label>
									<i></i>
									<b>
										{reservation.totalAmounWithoutDiscount?.toLocaleString(
											"en-US"
										)}{" "}
										ریال
									</b>
								</li>
								<li>
									<label>تخفیف</label>
									<i></i>
									<b>{reservation.discount?.toLocaleString("en-US")} ریال</b>
								</li>
								<li>
									<label>مبلغ کوپن تخفیف</label>
									<i></i>
									<b>
										{reservation.couponDiscount?.toLocaleString("en-US")} ریال
									</b>
								</li>
								<li>
									<label>هزینه پرداختی</label>
									<i></i>
									<b>{reservation.totalAmount?.toLocaleString("en-US")} ریال</b>
								</li>
							</ul>
							{reservation.items.map((item) => (
								<div>
									<h2>{item.notes}</h2>
									<div class="item-info">
										<span>{toPersian10DigitDate(item.reserveDate)}</span>
										<b>{item.quantity} نفر</b>
									</div>
									<div class="price">
										<span>{item.unitCost.toLocaleString("en-US")}</span>
										<b>با {item.discount.toLocaleString("en-US")} ریال تخفیف</b>
										<strong>
											{item.totalAmount.toLocaleString("en-US")} ریال
										</strong>
									</div>
								</div>
							))}
						</div>
					)}
				</>
			)}
		</article>
	);
}
